import { SystemField } from "./system-field";

export class Contact extends SystemField { 
    contact_type?:string;
    value?:string;
    ordering?:number;
    parent_id?:string;
}
export class ContactTranslateModel extends SystemField{ 
     lang_code?:string;
     label?:string;
     description?:string;
     contact_id?:string;
}
